import { useState } from "react";
import { supabase } from "../supabaseClient";
import "../styles/Login.css";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please fill in both fields.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Invalid email format.");
      return;
    }

    setLoading(true);

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
    } else {
      navigate("/");
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="brand">
          <img
            src="/Digital Subscriptions.png"
            alt="UnlokDigital Logo"
            className="logo-img"
          />
          <h1>UnlokDigital</h1>
          <p>Your digital content gateway</p>
        </div>
        <div className="left-message">
          <h2>Welcome to UnlokDigital</h2>
          <p>
            Login to explore premium assets and download tools tailored for
            creatives.
          </p>
        </div>
      </div>

      <div className="login-right">
        <div className="login-card">
          <h3>Sign In</h3>
          <form onSubmit={handleLogin}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
            {error && <p className="error">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}
